module.exports = __webpack_public_path__ + "img/Pyrolysis_1.77d4432f.jpg";